/**
 * The single source of truth for GA4 event names.
 *
 * Event names are contracts with GA4: once data lands under a name, renaming it
 * in code splits the metric across old + new names in reports (this is exactly
 * what happened to the `calculator_*` events). So names live here as constants,
 * every `trackEvent` call references one, and the string values are never
 * changed once shipped.
 *
 * `generate_lead` and `book_appointment` follow GA4's recommended-event naming
 * so they slot cleanly into standard reporting; the rest are custom.
 */
export const AnalyticsEvent = {
  CtaClick: "cta_click",
  GenerateLead: "generate_lead",
  BookAppointment: "book_appointment",
  CalculatorComplete: "calculator_complete",
  FormStart: "form_start",
  // Existing values kept verbatim to preserve GA4 continuity, do not rename.
  CalculatorSelectPlant: "calculator_select_click",
  CalculatorExpandPlant: "calculator_click_expand",
} as const;

export type AnalyticsEventName =
  (typeof AnalyticsEvent)[keyof typeof AnalyticsEvent];
